import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import clientone from "../Assets/imgs/client-one.webp";
import clienttwo from "../Assets/imgs/client-two.webp";
import clientthree from "../Assets/imgs/client-three.webp";
import gsap from "gsap";
import {
  animateReviewChange,
  animateSideImageChange,
  clientsHeadingGSAP,
} from "../utils/GSAPFunctions";

const OurCilents = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState<"next" | "prev">("next");

  const imageRef = useRef<HTMLImageElement>(null);
  const nameRef = useRef<HTMLDivElement>(null);
  const designationRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const prevImageRef = useRef<HTMLImageElement>(null);
  const nextImageRef = useRef<HTMLImageElement>(null);

  const clientsRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (clientsRef.current) {
        clientsHeadingGSAP(clientsRef);
      }
    }, clientsRef);

    return () => ctx.revert(); // clean up
  }, []);

  const reviews = [
    {
      name: "Mahnoor Malik",
      designation: "CEO & Managing Partner",
      content: `“When working with DBX360, I never felt like a client. Her ability to read between the lines of any business plan to determine the most cost-effective, efficient way to move forward is uncanny. Not only that, she goes above and beyond – learning about the team dynamics to ensure everyone is working cohesively toward a common goal. I’ve never felt so empowered to take on the challenges of growing a new business than I have when working with Josh”`,
      image: clientone,
    },
    {
      name: "Alina Khan",
      designation: "CTO, DevSolutions",
      content: `“Working with DBX360 was a transformational experience. Their expertise in brand development helped us reposition our product in a crowded marketplace.”`,
      image: clienttwo,
    },
    {
      name: "Ali Rehman",
      designation: "Marketing Director",
      content: `“I’ve never worked with a team that so deeply understood our goals and delivered such impactful campaigns. DBX360 made marketing easy and effective.”`,
      image: clientthree,
    },
  ];

  // 🔁 Add these two lines here — before JSX
  const prevIndex = (activeIndex - 1 + reviews.length) % reviews.length;
  const nextIndex = (activeIndex + 1) % reviews.length;

  // Animate content when activeIndex changes
  useEffect(() => {
    animateReviewChange({
      imageRef,
      nameRef,
      designationRef,
      contentRef,
      direction,
      onComplete: () => {},
    });
  }, [activeIndex]);

  const handleSlide = (dir: "next" | "prev") => {
    // Animate out current content
    gsap
      .timeline()
      .to(imageRef.current, {
        x: dir === "next" ? -100 : 100,
        opacity: 0,
        duration: 0.3,
        ease: "power2.inOut",
      })
      .set(imageRef.current, { x: dir === "next" ? 100 : -100 })
      .set([nameRef.current, designationRef.current, contentRef.current], {
        y: 50,
        opacity: 0,
      })
      .add(() => {
        // Set direction for useEffect
        setDirection(dir);

        // Update active index
        const newIndex =
          dir === "next"
            ? (activeIndex + 1) % reviews.length
            : (activeIndex - 1 + reviews.length) % reviews.length;

        setActiveIndex(newIndex);

        // Animate side image movement
        animateSideImageChange({
          prevImageRef: prevImageRef.current,
          nextImageRef: nextImageRef.current,
          direction: dir,
        });
      });
  };

  return (
    <div className="__ourClient" ref={clientsRef}>
      <div className="container-fluid">
        <div className="__fromOur" id="s_sub_heading">
          HEAR IT FROM OUR
        </div>
        <div className="__servicesHeading" id="banner_mheading">
          <div className="c_char">C</div>LIENTS
        </div>
        <div className="__ourClientSlider">
          <div className="row">
            <div className="col-lg-3">
              <div className="__clientsImgsCard d-desktop">
                <div className="__clientImgs">
                  <div className="__clientOne __client __client--prev ">
                    <img
                      src={reviews[prevIndex].image}
                      ref={prevImageRef}
                      className="__clientPrev"
                      alt="Previous client"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12">
              <div className="__reviewsCard">
                <div className="__prevNextBtn">
                  <button
                    className="__reviewPrevBtn"
                    onClick={() => handleSlide("prev")}
                  >
                    <div className="__floatLeft">
                      <i className="ri-arrow-left-line"></i>
                    </div>
                    <div className="__absfloatLeft">
                      <i className="ri-arrow-left-line"></i>
                    </div>
                  </button>
                  <button
                    className="__reviewNextBtn"
                    onClick={() => handleSlide("next")}
                  >
                    <div className="__floatRight">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                    <div className="__absfloatRight">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </button>
                </div>
                <div className="__clientsImgsCard">
                  <div className="__clientImgs">
                    <div className="__clienttwo __client  __client--active">
                      <img
                        src={reviews[activeIndex].image}
                        ref={imageRef}
                        className="__clientMain"
                        alt="Current client"
                      />
                    </div>
                  </div>
                </div>
                <div className="overflow-hidden">
                  <div className="__reviewHeading" ref={nameRef}>
                    {reviews[activeIndex].name}
                  </div>
                </div>
                <div className="overflow-hidden">
                  <div className="__designation" ref={designationRef}>
                    {reviews[activeIndex].designation}
                  </div>
                </div>
                <div className="__reviewIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="57"
                    height="54"
                    viewBox="0 0 57 54"
                    fill="none"
                  >
                    <path
                      className="star"
                      d="M35.2288 18.1385C34.5527 22.5592 36.8333 25.3963 38.8747 26.8395M32.2666 38.0795C33.0199 36.9619 33.5644 35.7195 34.2644 34.5675C34.6244 33.9758 35.0515 33.3865 35.6734 33.0765C36.0312 32.8987 36.4314 32.824 36.8258 32.7559C38.296 32.5016 39.7856 32.3027 41.2047 31.8473C41.9255 31.6169 42.6356 31.3128 43.2086 30.8226C43.9128 30.2184 44.3179 29.2923 44.2158 28.3615C44.1137 27.4307 43.5207 26.6137 42.9191 25.8747C41.2936 23.8793 39.1316 22.1997 38.7369 19.5097C38.6176 18.695 38.7793 17.8711 38.8375 17.0514C38.9046 16.0879 38.8268 15.1196 38.748 14.1561C38.6971 13.5256 38.6556 12.7329 38.3249 12.1742C37.9567 11.5503 37.075 11.2331 36.3949 11.1695C35.5909 11.0937 34.788 11.2881 34.0206 11.5295C32.3716 12.0472 30.9424 12.9446 29.3539 13.5753C29.0564 13.693 28.7467 13.797 28.4254 13.7951C28.0997 13.7939 27.7839 13.6836 27.4768 13.5747C25.2752 12.7976 23.0078 11.7371 20.652 11.6314C20.0118 11.6024 19.3474 11.7271 18.8309 12.0972C18.3123 12.469 17.9862 13.0595 17.831 13.6763C17.6758 14.2931 17.6758 14.938 17.7091 15.5748C17.7937 17.182 18.0788 18.7725 18.3643 20.3592C18.431 20.7289 18.496 21.1136 18.3923 21.4732C18.3067 21.7686 18.1125 22.0194 17.9223 22.2616C16.8088 23.6842 15.6854 25.0995 14.5825 26.531C13.8051 27.5409 13.1897 28.9309 13.8794 30.1673C14.5065 31.2924 15.7699 31.739 16.942 32.0554C17.6157 32.2377 18.2911 32.4194 18.9754 32.5564C20.0214 32.7659 21.2411 32.7624 22.1459 33.397C22.4506 33.6105 22.6942 33.8969 22.9217 34.189C24.2647 35.9126 25.2667 37.8776 26.743 39.5027C27.5101 40.3474 28.5974 40.9265 29.702 40.4261C30.8066 39.9258 31.6206 39.0429 32.2704 38.08L32.2666 38.0795Z"
                      stroke="#5E29F9"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      data-svg-origin="28.905773162841797 25.882349967956543"
                      transform="matrix(1,0,0,1,0,0)"
                    ></path>
                    <path
                      className="lines"
                      d="M50.2451 30.3207L55.8331 32.5057M31.2428 47.1617L32.2579 53.0752M7.08393 28.8568L1.17041 29.8719M15.4704 5.73513L11.547 1.19568M41.8082 6.23674L45.2712 1.33702"
                      stroke="#5E29F9"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      data-svg-origin="28.501754641532898 27.135440230369568"
                      transform="matrix(1,0,0,1,0,0)"
                    ></path>
                  </svg>
                </div>
                <div className="overflow-hidden">
                  <div className="__reviewDesc" ref={contentRef}>
                    {reviews[activeIndex].content}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="__clientsImgsCard d-desktop">
                <div className="__clientImgs">
                  <div className="__clienthree __client __client--next">
                    {/* <img src={clientthree} alt="client" /> */}
                    <img
                      src={reviews[nextIndex].image}
                      ref={nextImageRef}
                      className="__clientNext"
                      alt="Next client"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurCilents;
